<template>
	<b-container fluid class="mt-5 p-0">
		<b-card no-body>
			<b-card-header class="container-fluid">
				<b-row>
					<b-col xl="6">
						<div class="h3">Check Balance of Broadband Subscriber</div>
					</b-col>
					<b-col xl="6" class="text-right">
						<b-button size="sm" variant="success" v-on:click="addNewBroadBand"
							>Add New Broadband Subscriber
						</b-button>
					</b-col>
				</b-row>
			</b-card-header>

			<b-card-body>
				<b-row>
					<b-col lg="12" md="12">
						<b-row>
							<b-col lg="6" md="6" sm="8">
								<div class="d-flex w-100">
									<label class="h3 pt-1 mr-4 w-50 text-right nowrap">Mac Address</label>
									<b-form-input
										id="input-1"
										size="sm"
										v-model="newBroadBandForm.address"
									></b-form-input>
								</div>
							</b-col>
							<b-col lg="6" md="6" sm="4" class="text-sm-left text-right">
								<base-button type="primary" title="Search" size="sm" v-on:click="lookupBroadBand" :loading="submitLoading">
									<i v-if="!submitLoading" class="fas fa-search">  </i>  Search
								</base-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</b-card-body>
		</b-card>

		<div class="mt-4" v-if="tableDisplayStatus">
			<div class="text-center w-100">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="loadingStatus"
				></b-icon>
			</div>
			<div class="mb-3" v-if="!loadingStatus">
				<b-row>
					<b-col cols="12" xl="8" lg="7" md="7" sm="6">
						<b-form-group
							label=""
							label-for="per-page-select"
							label-cols-sm="0"
							label-cols-md="0"
							label-cols-lg="0"
							label-align-sm="center"
							class="mb-2 per-page-select"
						>
						<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
						<b-form-select
							id="per-page-select"
							class="diameter-report-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
							v-on:input="changePageOption(perPage)"
						></b-form-select>
						</b-form-group>
					</b-col>

					<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
						<b-form-group
							label=""
							label-for="filter-input"
							label-align-sm="right"
							label-size="sm "
							class="mb-0 per-page-select"
						>
							<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
							<b-input-group size="sm">
								<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>
				<div class="">
					<b-table
						striped
						hover
						:items="tableData"
						:fields="tableColumns"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						:filter-included-fields="filterOn"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						:sort-direction="sortDirection"
						head-variant="light"
						table-class="text-nowrap"
						class="data-management-table primary-table"
						sticky-header="true"
						thead-class="white"
						show-empty
						responsive
						small
						@sort-changed="headerColumnChanged"
						@filtered="onFiltered"
					>
						<template #cell(action)="row">
							<span class="nowrap">
								<i
									class="fas fa-plus-circle mr-3 text-success"
									data-toggle="tooltip"
									data-original-title="Add a data bucket to the subscriber"
									v-b-modal.top-off-plans-subscriber
									v-on:click="editBroadBand(row.item.macaddress)"
								></i>
								<i
									class="fas fa-trash-alt cursor-pointer text-danger"
									data-toggle="tooltip"
									:data-original-title="
										'Delete existing data buckets for the subscriber.' + row.item.macaddress
									"
									v-on:click="deleteBroadBand(row.item.macaddress)"
								></i>
							</span>
						</template>
						<template #cell(plan_status)="row">
							<b-link v-on:click="showActive" class="cursor-pointer nowrap">
								{{ row.item.plan_status }} <i class="ni ni-curved-next ml-1"></i>
							</b-link>
						</template>
					</b-table>
				</div>
				<b-row class="mt-4">
					<b-col >
						<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
					</b-col>
					<b-col >
						<b-pagination
							class="flex-fill-custom pr-4 ml-3 justify-content-end"
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
						></b-pagination>
					</b-col>
				</b-row>
			</div>
		</div>

		<b-modal
			centered
			size="lg"
			id="new-broadband-check"
			hide-footer
			:title="brandTitle"
			class="new-broadband-check"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<NewBroadbandSubscriber></NewBroadbandSubscriber>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="top-off-plans-subscriber"
			hide-footer
			title="Top Off Plans"
			class="top-off-plans-subscriber"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<TopOffPlansSubscriber></TopOffPlansSubscriber>
		</b-modal>
	</b-container>
</template>

<script>
import TopOffPlans from "../../../Components/Top-Off-Plans";
import administratorService from "../../../../common/api-services/administrator-service";
import swal from "sweetalert2";
import NewBroadbandSubscriber from "../../../Components/Add-Broadband-Subscriber";
import TopOffPlansSubscriber from "../../../Components/Top-Off-Plans-Subscriber";
import handleResponse from "../../../../common/directive/handlResponse";
import pagination from '../../../../common/format/pagination'

export default {
	name: "BroadbandBalanceCheck",
	components: {TopOffPlansSubscriber, NewBroadbandSubscriber, TopOffPlans},
	data() {
		return {
			newBroadBandForm: {
				address: "",
			},
			loadingStatus: false,
			tableDisplayStatus: false,
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			tableColumns: [
				{key: "macaddress", label: "Mac Address", sortable: true, sortDirection: "desc"},
				{key: "plan_name", label: "Data Plan", sortable: true, sortDirection: "desc"},
				{key: "balance", label: "Balance", sortable: true, sortDirection: "desc"},
				{key: "end_date", label: "Expires", sortable: true, sortDirection: "desc"},
				{key: "plan_status", label: "Status", sortable: true, sortDirection: "desc"},
				{key: "action", label: "", sortable: true, sortDirection: "desc"},
			],
			tableData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			loadingNum: 1,
			paginationLoadingBar: true,
			brandTitle: "",
			submitLoading: false,
		};
	},
	mounted() {
		this.$root.$on("newBrandSubscriberAdded", res => {
			if (res) {
				this.lookupBroadBand();
			}
		});
		this.getTotalRows();
	},
	methods: {
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		headerColumnChanged(e) {
			this.sortBy = e.sortBy;
			if (e.sortDesc === true) {
				this.sortDirection = "asc";
			} else {
				this.sortDirection = "desc";
			}
			this.getTopOffPlansFunc();
		},

		addNewBroadBand() {
			this.brandTitle = "Add New Broadband Subscriber";
			this.$bvModal.show("new-broadband-check");
		},

		lookupBroadBand() {
			if (this.newBroadBandForm.address) {
				this.tableDisplayStatus = true;
				this.submitLoading = true;
				this.loadingStatus = true;
				this.tableData = [];
				administratorService.getDslPlanAndBalance(this.newBroadBandForm.address).then(res => {
					this.loadingStatus = false;
					this.submitLoading = false;
					if (res) {
						this.tableData.push(res);
						this.totalRows = this.tableData.length;
						this.getTotalRows();
					}
				});
			}
		},

		changePageOption(page) {
			this.getTotalRows();
		},

		editBroadBand(msisdn) {
			setTimeout(() => {
				this.$root.$emit("editTopOffPlansSub", msisdn);
			}, 400);
		},

		deleteBroadBand(id) {
			swal.fire({
				title: `Delete Subscriber Broadband Data and Plan`,
				text: `Delete all for subscriber? ${this.newBroadBandForm.address}`,
				buttonsStyling: false,
				showCloseButton: true,
				showCancelButton: true,

				confirmButtonText: "Delete",
				cancelButtonText: "Cancel",
				//cancelButtonClass: 'btn btn-danger',
			}).then(result => {
				if (result.isConfirmed) {
					administratorService.delDslPLanAndBalance(id).then(res => {
						let {type, msg} = handleResponse.apiResponse(res);
						this.lookupBroadBand();
						this.$toast(msg, {type: type})
					});
				}
			});
		},

		showActive() {
			let iframeURL =
				"http://kibana.dccllc.net:8085/graphs/queue/<hotspot-" + this.newBroadBandForm.address + ">";
			this.$router.push({name: "Broadband Graphs"});
			setTimeout(() => {
				this.$root.$emit("showBroadBandActive", iframeURL);
			}, 2000);
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},
	},
};
</script>
